import { showNotify } from 'vant';
import PageNavLayoutCpt from '@/components/page/PageNavLayoutCpt';
import { mapMutations } from 'vuex';
import { SPECIAL_HEADER, setAuthorization } from '@/utils/request';
import { rqtPostWechatLogin, rqtGetUserWechatLoginMobileSms, rqtPostUserWechatLoginMobile } from '@/services/common';
import { ls } from '@/utils/aes';
export default {
  components: {
    PageNavLayoutCpt
  },
  data() {
    return {
      imgflag: false,
      checkedImg: require('@/assets/img/icon_checked.png'),
      unCheckedImg: require('@/assets/img/icon_unchecked.png'),
      mobile: '',
      validateCode: '',
      codeLoading: false,
      logging: false,
      wxInfo: {},
      isShowPage: false,
      btnShow: true,
      isDisable: true,
      secText: '重新获取',
      //倒计时提示文字
      sec: 60 //初始化倒计时秒数
    };
  },

  created() {
    let code = this.$route.query && this.$route.query.code;
    let state = this.$route.query && this.$route.query.state;
    /* if(this.$route.query.routeFlag) {
      this.isShowPage = true
    }else {
      this.isShowPage = false
    } */
    if (!code) {
      const params = new URLSearchParams(window.location.search);
      code = params.get('code');
      state = params.get('state');
    }
    // state=1000009 微信公众号财富核心
    if (code && state == 1000009) {
      rqtPostWechatLogin({
        code
      }).then(res => {
        const resData = res.data.data;
        this.wxInfo = resData;
        // localStorage.setItem('wxOpenId', Base64.encode(JSON.stringify(this.wxInfo.openId)))

        if (this.wxInfo.customerId) {
          this.afterLogin(res);
        } else {
          this.isShowPage = true;
        }
      }).catch(() => {});
    }
  },
  methods: {
    ...mapMutations('account', ['setUser', 'setPermissions', 'setRoles']),
    onSubmit(values) {
      if (!this.imgflag) {
        this.$dialog.alert({
          message: '请先阅读并接受隐私政策'
        }).catch(() => {});
        return;
      }
      if (values) {
        this.logging = true;
        rqtPostUserWechatLoginMobile({
          mobile: this.mobile,
          validateCode: this.validateCode,
          openId: this.wxInfo.openId
        }).then(this.afterLogin).catch(err => {
          this.logging = false;
          console.error(err);
        });
      }
    },
    afterLogin(res) {
      this.logging = false;
      const loginRes = res.data;
      if (loginRes.code === 1000) {
        // refactor res
        const user = {
          name: 'Admin',
          avatar: '',
          address: '浙江省杭州市西湖区',
          position: '公元大厦'
        };
        const {
          [SPECIAL_HEADER.xsrfHeaderName.toLowerCase()]: accesstoken,
          [SPECIAL_HEADER.refreshToken.toLowerCase()]: refreshtoken
        } = res.headers;
        user.name = loginRes.data.agentName || loginRes.data.userName;
        user.refreshtoken = refreshtoken;
        user.userId = loginRes.data.userId;
        user.branchId = loginRes.data.branchId;
        user.branchName = loginRes.data.branchName;
        user.departmentId = loginRes.data.departmentId;
        user.agentId = loginRes.data.agentId;
        user.avatar = loginRes.data.headUrl;
        // customerId
        user.customerId = loginRes.data.customerId;
        // isSetPwd
        user.isSetPwd = loginRes.data.isSetPwd;
        ls.set('pubkey', res.headers[SPECIAL_HEADER.publicKey.toLowerCase()]);
        if (user.branchName) {
          user.name = user.branchName + '-' + user.name;
        }
        const expireAt = new Date(new Date().getTime() + 4 * 60 * 60 * 1000);
        this.setUser(user);
        setAuthorization({
          token: accesstoken,
          expireAt: new Date(expireAt)
        });
        // init router by fetch
        // const { menuRouter, permissions } = this.initRoutesConfig(loginRes.data.privilegeMap)
        // this.setPermissions(permissions)
        // loadRoutes(menuRouter)
        // this.isShowPage = false
        this.$router.replace('/wx/main');
      } else {
        this.error = loginRes.msg;
      }
    },
    onFreshCodeClick() {
      if (!this.mobile) {
        showNotify('请输入手机号');
        return;
      }
      this.codeLoading = true;
      rqtGetUserWechatLoginMobileSms({
        mobile: this.mobile
      }).then(() => {
        // const resData = res.data.data
        showNotify({
          message: '验证码已发送',
          type: 'success'
        });
        this.codeLoading = false;
        this.btnShow = false;
        let timer = setInterval(() => {
          this.sec = this.sec - 1;
          this.secText = this.sec + 's重新获取';
          this.btnShow = false;
          if (this.sec === 0) {
            clearInterval(timer);
            this.sec = 60;
            this.secText = '重新获取';
            this.isDisable = false;
            // this.btnShow = true
          }
        }, 1000);
      }).catch(() => {
        this.codeLoading = false;
      });
    },
    //重新获取验证码
    getNewCode() {
      if (!this.mobile) {
        showNotify('请输入手机号');
        return;
      }
      this.isDisable = true;
      this.codeLoading = true;
      rqtGetUserWechatLoginMobileSms({
        mobile: this.mobile
      }).then(() => {
        showNotify({
          message: '验证码已发送',
          type: 'success'
        });
        this.codeLoading = false;
        this.btnShow = false;
        let timer = setInterval(() => {
          this.sec = this.sec - 1;
          this.secText = this.sec + 's重新获取';
          this.btnShow = false;
          if (this.sec === 0) {
            clearInterval(timer);
            this.sec = 60;
            this.secText = '重新获取';
            this.isDisable = false;
            // this.btnShow = true
          }
        }, 1000);
      }).catch(err => {
        console.error(err);
      });
    },
    test() {
      this.imgflag = !this.imgflag;
    }
  }
};